import axios from "../config/axios";
import Constants from "../data/Constants";

export const getCouponsList = async (filters = {}, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.COUPON.ALL, {
      params: filters,
    })
    .then((res) => {
      return res.data.result;
    });
};

export const updateSingleCoupon = async (id, data) => {
  return await axios
    .patch(Constants.ENDPOINTS.COUPON.UPDATE + id, data)
    .then((res) => {
      return res.data.result;
    });
};

export const createSingleCoupon = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.COUPON.CREATE, data)
    .then((res) => {
      return res.data.result;
    });
};

export const deleteSingleCoupon = async (id, data) => {
  return await axios
    .delete(Constants.ENDPOINTS.COUPON.DELETE + id, data)
    .then((res) => {
      return res.data.result;
    });
};
